export default __webpack_public_path__ + "assets/druid.ca9c6f80.svg";